// GENERATED FROM 'messages.json' (via yarn run messages:generate)
// !! DO NOT CHANGE MANUALLY !!

import { type ReactElement } from "react";

import { FormattedMessage } from "react-intl";

export const CreateOrganizationAndLensFolderHeader = (): ReactElement => (
    <FormattedMessage
        id="apps.createOrgLensFolder.components.createOrganizationAndLensFolderHeader"
        description="Create organization and lens folder header."
        defaultMessage="Set up an Organization and a Lens Folder"
    />
);
CreateOrganizationAndLensFolderHeader.displayName = "CreateOrganizationAndLensFolderHeader";

export const CreateOrganizationAndLensFolderSubHeader = (): ReactElement => (
    <FormattedMessage
        id="apps.createOrgLensFolder.components.createOrganizationAndLensFolderSubHeader"
        description="Create organization and lens folder sub header."
        defaultMessage="You need to set up an Organization and a Lens Folder."
    />
);
CreateOrganizationAndLensFolderSubHeader.displayName = "CreateOrganizationAndLensFolderSubHeader";

export const CreateLensFolder = (): ReactElement => (
    <FormattedMessage
        id="apps.createOrgLensFolder.components.createLensFolder"
        description="Create lens folder."
        defaultMessage="Create Lens Folder"
    />
);
CreateLensFolder.displayName = "CreateLensFolder";

export const CreateOrganizationFailed = (): ReactElement => (
    <FormattedMessage
        id="apps.createOrgLensFolder.components.createOrganizationFailed"
        description="Create organization failed."
        defaultMessage="Unable to create the Organization and Lens Folder. Please try again."
    />
);
CreateOrganizationFailed.displayName = "CreateOrganizationFailed";
